const my_profile = {
  viewMyClubSeacretProfile: "私のClubSecretプロフィールを見る", // translated
  viewMoreDetails: "詳細を見る", // translated
  verifiedEmail: "確認済みメールアドレス", // translated
  unverifiedEmail: "未確認のメール", // translated
  pointsOut: "指摘している", // translated
  pointsIn: "ポイントイン", // translated
  balance: "バランス", // translated
  pointsHistoryTable: "ポイント履歴テーブル", // translated
  topUp: "補充する", // translated
  createdFrom: "作成日（開始）", // translated
  createdTo: "作成日（終了）", // translated
  selectStatus: "ステータスを選択...", // translated
  searchByTitle: "タイトルで検索...", // translated
  offerStatus: "オファーステータス", // translated
  selectOfferStatus: "すべて", // translated
  quotationSent: "見積もり送信済み", // translated
  offerInProgress: "オファー進行中", // translated
  offerAvailable: "オファー利用可能", // translated
  offerAccepted: "オファー承認済み", // translated
  offerExpired: "オファー期限切れ", // translated
  pushNotifications: "プッシュ通知",
  pushNotificationsDescription: "重要な更新やイベントのブラウザ通知を受信",
  pushNotificationsNotSupported: "このブラウザではプッシュ通知がサポートされていません",
  pushNotificationsDeniedMessage: "通知の許可が拒否されました。プッシュ通知を受信するには、ブラウザの設定で通知を有効にしてください。",
  pushNotificationsEnabled: "プッシュ通知が正常に有効化されました",
  pushNotificationsDisabled: "プッシュ通知が正常に無効化されました",
  userInformationMissing: "ユーザー情報が不足しています",
  failedToUpdatePushNotifications: "プッシュ通知設定の更新に失敗しました",
  notificationPermissionDenied: "通知の許可が拒否されました。ブラウザの設定で有効にしてください。",
  notificationPermissionRequired: "プッシュ通知を有効にするには通知の許可が必要です",
  notSupported: "サポートされていません",
  permissionDenied: "許可が拒否されました",
  permissionNotRequested: "許可が要求されていません",
  enabled: "有効",
  disabled: "無効",
};

export default my_profile;
